import React from "react";
import { Btn } from "../components";
import { T } from "../theme";

type Props = {
  onStart: () => void;
  onSignIn: () => void;
  isMobile: boolean;
};

export function WelcomeScreen({ onStart, onSignIn, isMobile }: Props): React.ReactElement {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: T.bgHero,
        color: T.fg,
        display: "flex",
        flexDirection: "column",
        zIndex: 250,
        fontFamily: "'Inter', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, Arial",
      }}
    >
      {/* faint ambient glow */}
      <div
        aria-hidden
        style={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          background:
            "radial-gradient(closest-side at 30% 30%, rgba(132,204,22,0.07), transparent 60%), radial-gradient(closest-side at 70% 70%, rgba(59,130,246,0.07), transparent 60%)",
        }}
      />
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 28px",
          position: "relative",
        }}
      >
        <div
          aria-hidden
          style={{
            width: 72,
            height: 72,
            borderRadius: 20,
            background: T.lime,
            display: "grid",
            placeItems: "center",
            color: "#0a0e14",
            fontWeight: 900,
            fontSize: "2rem",
            letterSpacing: "-0.04em",
          }}
        >
          W
        </div>
        <div
          style={{
            marginTop: 36,
            fontSize: isMobile ? "2.0rem" : "2.4rem",
            fontWeight: 700,
            letterSpacing: "-0.025em",
            textAlign: "center",
            lineHeight: 1.1,
            maxWidth: 340,
          }}
        >
          Hit your weight goal.
          <br />
          Every time.
        </div>
        <div
          style={{
            marginTop: 14,
            color: T.fg2,
            fontSize: "1.0rem",
            textAlign: "center",
            maxWidth: 320,
            lineHeight: 1.45,
            fontWeight: 500,
          }}
        >
          A weekly-adjusting plan, built around how you actually train and live.
        </div>
      </div>

      <div
        style={{
          padding: isMobile
            ? "0 20px max(36px, env(safe-area-inset-bottom))"
            : "0 28px 36px",
          display: "flex",
          flexDirection: "column",
          gap: 10,
          position: "relative",
        }}
      >
        <Btn kind="primary" size="xl" full onClick={onStart}>
          Build my plan
        </Btn>
        <Btn kind="ghost" size="md" full onClick={onSignIn}>
          I already have an account
        </Btn>
      </div>
    </div>
  );
}
